import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'

import { useGetQRASavedStateQuery } from 'app/services/api/qra/savedstates'
import { useGetCurrentUserIdQuery } from 'app/services/api/users'
import { WISAssessmentStatusCode } from 'features/RiskManagement/Assessments/WISAssessmentStatusCode'
import { WISCreateModalQueryString } from 'features/RiskManagement/Assessments/Scenarios/WISCreateModalQueryString'

interface ICreateScenarioButtonWithPopup {
  stateId?: string
}

const CreateScenarioButtonWithPopup = ({
  stateId
}: ICreateScenarioButtonWithPopup) => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { currentData: currentUserId } = useGetCurrentUserIdQuery()
  const { currentData: state } = useGetQRASavedStateQuery(stateId ?? skipToken)
  const [canRunScenario, setCanRunScenario] = useState<boolean>(true)

  useEffect(() => {
    // TODO: Check if there are data to run assessment on.
    if (state != null) {
      const hasInProcessAssessmentByCurrentUser = state.assessments?.some(
        (assessment) => {
          const isOwnedByCurrentUser = assessment.userId === currentUserId

          let isInProcess = false

          switch (assessment.statusCode) {
            case WISAssessmentStatusCode.New:
            case WISAssessmentStatusCode.DataPreparation:
            case WISAssessmentStatusCode.InProcess:
            case WISAssessmentStatusCode.RunningModels:
            case WISAssessmentStatusCode.PopulatingToDB:
            case WISAssessmentStatusCode.PostProcessing:
            case WISAssessmentStatusCode.PopulatingToMap: {
              isInProcess = true

              break
            }
          }

          return isInProcess && isOwnedByCurrentUser
        }
      )

      setCanRunScenario(!hasInProcessAssessmentByCurrentUser)
    }
  }, [state, currentUserId])

  const openWISModal = (): void => {
    const searchParams = new URLSearchParams(search)

    searchParams.set(WISCreateModalQueryString.IsOpen, 'true')
    navigate(`${pathname}?${searchParams.toString()}`)
  }

  return (
    <>
      <hr />
      <button
        className={['mt-2', 'text-lighthouseBlue', 'disabled:opacity-50'].join(
          ' '
        )}
        onClick={openWISModal}
        disabled={!canRunScenario}
      >
        Run New Scenario
      </button>
    </>
  )
}

export default CreateScenarioButtonWithPopup
